import React, { PureComponent } from 'react';
import styles from './chips-list.scss';
import ImageAvatar from 'ui/image/image-avatar';
import { ICON_CLOSE } from 'icons';
import ChipsItemProps from '../fields';

interface ChipsItemState {}
export default class ChipsItem extends PureComponent<ChipsItemProps, ChipsItemState> {
  handleRemove = () => {
    const { onRemove } = this.props;
    if (onRemove) onRemove(this.props.value);
  };

  renderIcon(icon) {
    if (React.isValidElement(icon)) return <div className={styles.materialIcons}>{icon}</div>;
    else return <ImageAvatar small className={styles.imageAvatar} image={icon} />;
  }

  render() {
    const { icon, value, label } = this.props;
    if (!value) return;
    return (
      <div className={styles.chip}>
        {icon && this.renderIcon(icon)}
        {value && <div className={styles.text}>{label || value}</div>}
        {
          <div className={styles.closeIcon} onClick={this.handleRemove}>
            {ICON_CLOSE}
          </div>
        }
      </div>
    );
  }
}
